import { render, staticRenderFns } from "./ProductTiles.vue?vue&type=template&id=b26a4602"
import script from "./ProductTiles.vue?vue&type=script&lang=ts"
export * from "./ProductTiles.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports